import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Card, CardContent, CardDescription, CardFooter, CardHeader } from '../components/ui/Card';
import { LockIcon, MailIcon } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/rvAH9mmpehfrmFnpSd4p81/dashboard.png';
interface LoginProps {
  onLogin: () => void;
}
export function Login({
  onLogin
}: LoginProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      onLogin();
    }, 1000);
  };
  return <div className="min-h-screen w-full flex items-center justify-center p-4" style={{
    background: 'linear-gradient(135deg, #021d38 0%, #034076 40%, #04508f 70%, #034076 100%)'
  }} data-id="element-311">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff08_1px,transparent_1px),linear-gradient(to_bottom,#ffffff08_1px,transparent_1px)] bg-[size:14px_24px]" data-id="element-312"></div>

      <Card className="w-full max-w-md relative z-10 border-border/50 shadow-2xl bg-white backdrop-blur-xl" data-id="element-313">
        <CardHeader className="space-y-4 text-center pb-6" data-id="element-314">
          <div className="mx-auto mb-2" data-id="element-315">
            <img src={LOGO_URL} alt="Dashboard de Control Aperturas y Cierres" className="h-24 w-auto mx-auto" data-id="element-316" />
          </div>
          <CardDescription className="text-gray-500" data-id="element-317">
            Ingresa tus credenciales para acceder al dashboard
          </CardDescription>
        </CardHeader>
        <form onSubmit={handleSubmit} data-id="element-318">
          <CardContent className="space-y-4" data-id="element-319">
            <div className="space-y-2" data-id="element-320">
              <label className="text-sm font-medium leading-none text-gray-700" htmlFor="email" data-id="element-321">
                Correo Electrónico
              </label>
              <div className="relative" data-id="element-322">
                <MailIcon className="absolute left-3 top-3 h-4 w-4 text-gray-400" data-id="element-323" />
                <Input id="email" type="email" placeholder="admin@example.com" className="pl-9 bg-gray-100 border-gray-200 text-gray-800 placeholder:text-gray-400" value={email} onChange={e => setEmail(e.target.value)} required data-id="element-324" />
              </div>
            </div>
            <div className="space-y-2" data-id="element-325">
              <div className="flex items-center justify-between" data-id="element-326">
                <label className="text-sm font-medium leading-none text-gray-700" htmlFor="password" data-id="element-327">
                  Contraseña
                </label>
                <a href="#" className="text-sm text-[#034076] hover:underline" data-id="element-328">
                  ¿Olvidaste tu contraseña?
                </a>
              </div>
              <div className="relative" data-id="element-329">
                <LockIcon className="absolute left-3 top-3 h-4 w-4 text-gray-400" data-id="element-330" />
                <Input id="password" type="password" placeholder="••••••••" className="pl-9 bg-gray-100 border-gray-200 text-gray-800 placeholder:text-gray-400" value={password} onChange={e => setPassword(e.target.value)} required data-id="element-331" />
              </div>
            </div>
          </CardContent>
          <CardFooter data-id="element-332">
            <Button className="w-full" type="submit" disabled={isLoading} data-id="element-333">
              {isLoading ? <div className="flex items-center space-x-2" data-id="element-334">
                  <div className="w-4 h-4 border-2 border-primary-foreground border-t-transparent rounded-full animate-spin" data-id="element-335" />
                  <span data-id="element-336">Autenticando...</span>
                </div> : 'Iniciar Sesión'}
            </Button>
          </CardFooter>
        </form>
      </Card>
    </div>;
}